// src/pages/dashbord/section/ExpenseSection.tsx
import React, { useState } from 'react';
import { Card, Row, Col } from 'antd';
import { DollarCircleOutlined } from '@ant-design/icons';
import ExpenseModal from '../../../components/ExpenseModal';
import ExpenseKPI from '../../../components/ExpenseKPI';
import ExpenseSplitDonut from '../../../components/ExpenseSplitDonut';
import ExpenseAllTimeChart from '../../../components/ExpenseAllTimeChart';
import ExpensesTable from '../../../components/ExpensesTable';
import ExpensesExportButton from '../../../components/ExpensesExportButton';
import StatusChips from '../../../ui/StatusChips';
import TableHeader from '../../../components/TableHeader';

type Props = {
  expensesFiltered: any[];
  expenseSeries: Array<{ date: string; expense: number; cumulative: number }>;
  expItems: any[];
  expStatusCounts: Record<string, number>;
  expActiveStatuses: string[];
  onToggleExpStatus: (key: string) => void;
  expenseSearch: string;
  onExpenseSearchChange: (s: string) => void;
  onResetColumns: () => void;
  colsVer: number;
  EXP_STATUS_META: Record<string, { label: string; chip: { bg: string; fg: string } }>;
  EXP_STATUS_LIST: readonly string[];
  onExpenseCreated?: () => void;
};

const ExpenseSection: React.FC<Props> = ({
  expensesFiltered,
  expenseSeries,
  expItems,
  expStatusCounts,
  expActiveStatuses,
  onToggleExpStatus,
  expenseSearch,
  onExpenseSearchChange,
  onResetColumns,
  colsVer,
  EXP_STATUS_META,
  EXP_STATUS_LIST,
  onExpenseCreated,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div style={{ marginTop: 16 }}>
        <ExpenseKPI source={expensesFiltered as any[]} />
      </div>

      <Row gutter={[16, 16]} style={{ marginTop: 28 }}>
        <Col xs={24} md={12} lg={10}>
          <ExpenseSplitDonut height={420} rangeDays={30} />
        </Col>
        <Col xs={24} md={12} lg={14}>
          <ExpenseAllTimeChart data={expenseSeries} height={420} />
        </Col>
      </Row>

      <Card
        variant="borderless"
        className="stat-card stat-card--accent-blue"
        style={{ marginTop: 16 }}
        styles={{ header: { paddingTop: 14, paddingBottom: 14, alignItems: 'center' } }}
        title={
          <TableHeader
            icon={<DollarCircleOutlined />}
            title="Расходы"
            chips={
              <StatusChips
                metas={EXP_STATUS_LIST.map((k) => ({
                  key: k,
                  label: EXP_STATUS_META[k].label,
                  bg: EXP_STATUS_META[k].chip.bg,
                  fg: EXP_STATUS_META[k].chip.fg,
                }))}
                counts={expStatusCounts}
                activeKeys={expActiveStatuses}
                onToggle={onToggleExpStatus}
                hideZero
              />
            }
            totalLabel="Всего расходов"
            totalValue={expItems.length}
            searchPlaceholder="№ расхода / Поставщик"
            searchValue={expenseSearch}
            onSearchChange={onExpenseSearchChange}
            onResetColumns={onResetColumns}
            exportButton={<ExpensesExportButton className="header-action-btn" source={expensesFiltered as any[]} />}
          />
        }
      >
        <ExpensesTable key={colsVer} expenses={expensesFiltered as any} maxRows={Number.POSITIVE_INFINITY} />
      </Card>

      <ExpenseModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onCreated={() => { setModalOpen(false); onExpenseCreated?.(); }}
      />
    </>
  );
};

export default ExpenseSection;
